
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collective",
      function () {
        return require("private-next-pages/collective/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collective"])
      });
    }
  